var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import TopUpMutation from "@irati/wallet/apollo/mutation/Topup";
import authentication from "@irati/auth";
import { FormattedMessage } from "@irati/utils/lang";
import TenantWalletBalanceQuery from "@irati/wallet/apollo/query/TenantWallet";
import { StyledButton } from "./styled";
var TopUpButton = /** @class */ (function (_super) {
    __extends(TopUpButton, _super);
    function TopUpButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.returnVariables = function (_a) {
            var currency = _a.currency, uuid = _a.uuid, ownerUuid = _a.ownerUuid;
            var _b = _this.props, amount = _b.amount, poNumber = _b.poNumber, type = _b.type;
            return {
                tenantId: authentication.userTenant().uuid,
                amount: parseFloat(amount),
                currency: currency,
                walletUuid: uuid,
                walletOwnerUuid: ownerUuid,
                type: type,
                poNumber: poNumber
            };
        };
        _this.handleError = function () {
            // @todo handle error
        };
        return _this;
    }
    TopUpButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, buttonText = _a.buttonText, onComplete = _a.onComplete, onClick = _a.onClick;
        return (React.createElement(TenantWalletBalanceQuery, null, function (_a) {
            var tenantWallet = _a.data.tenantWallet;
            var variables = _this.returnVariables(tenantWallet);
            return (React.createElement(TopUpMutation, { variables: variables, onCompleted: onComplete, onError: _this.handleError }, function (mutate, apolloState) {
                return (React.createElement(StyledButton, { primary: true, large: true, full: true, disabled: disabled, apolloState: apolloState, onClick: function () { return onClick(mutate); } },
                    React.createElement(FormattedMessage, { id: buttonText })));
            }));
        }));
    };
    return TopUpButton;
}(PureComponent));
export default TopUpButton;
